import {branchesNamesToString} from "utils/branches";
import makeFullName from "utils/makeFullName";

export const invitation = ({branches, agency, invitedBy}) => ({
  agencyName: agency?.name || "-",
  branches: branchesNamesToString(branches),
  invitedBy: makeFullName(invitedBy),
});
